<template>
    <span>
        <a v-if="isPhoneNumber || isMailTo" :href="to" :target="target" @click.stop="onClick(to, target)">
            <slot />
        </a>
        <router-link v-else-if="!_.isNull(to)" :to="clean" :target="target" @click.native.stop="onClick(clean, target)">
            <slot />
        </router-link>
        <template v-else>
            <span>
                <slot />
            </span>
        </template>
    </span>
</template>

<script>
export default {
    name: 'AppLink',
    props: {
        to: {
            type: [String, Object],
            default: null
        },
        target: {
            type: String,
            default: null
        }
    },
    computed: {
        isPhoneNumber() {
            return this._.isString(this.to) && this.to.includes('tel:');
        },
        isMailTo() {
            return this._.isString(this.to) && this.to.includes('mailto:');
        },
        clean() {
            if (!this._.isString(this.to)) {
                return this.to;
            }

            let url = this.to;

            if (url.includes('http://')) {
                url = url.replace('http://', '//');
            }

            if (url.includes('https://')) {
                url = url.replace('https://', '//');
            }

            return url;
        }
    },
    methods: {
        onClick(href, target) {
            if (target === '_blank') {
                window.open(href, '_blank');
            } else if (this.isPhoneNumber || this.isMailTo) {
                window.location.href = href;
            } else {
                this.go(href);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
button {
    text-align: inherit;
}
</style>
